(function () {
  var WW_POPUP_CODE = 'BIENVENUE10'; // doit correspondre exactement au code cree dans Shopify > Reductions
  var DELAY_MS = 25000;
  var DISMISS_COOLDOWN_DAYS = 7;
  var LS_SUBSCRIBED = 'ww_popup_subscribed';
  var LS_DISMISSED_AT = 'ww_popup_dismissed_at';

  var path = location.pathname;
  if (path === '/cart' || path.indexOf('/checkout') === 0 || path.indexOf('/account') === 0) return;

  function shouldSkip() {
    try {
      if (localStorage.getItem(LS_SUBSCRIBED) === '1') return true;
      var dismissedAt = parseInt(localStorage.getItem(LS_DISMISSED_AT) || '0', 10);
      if (dismissedAt && (Date.now() - dismissedAt) < DISMISS_COOLDOWN_DAYS * 86400000) return true;
    } catch (e) { /* stockage indisponible (navigation privee) : on affiche quand meme */ }
    return false;
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (shouldSkip()) return;
    var pop = document.getElementById('wwPopup');
    if (!pop) return;

    var backdrop = document.getElementById('wwPopupBackdrop');
    var closeBtn = document.getElementById('wwPopupClose');
    var form = document.getElementById('wwPopupForm');
    var submitBtn = document.getElementById('wwPopupSubmit');
    var body = document.getElementById('wwPopupBody');
    var success = document.getElementById('wwPopupSuccess');
    var error = document.getElementById('wwPopupError');
    var codeText = document.getElementById('wwPopupCodeText');
    var copyBtn = document.getElementById('wwPopupCopy');

    var timer = setTimeout(open, DELAY_MS);

    function open() {
      if (shouldSkip()) return;
      pop.classList.add('is-open');
      pop.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close(remember) {
      clearTimeout(timer);
      pop.classList.remove('is-open');
      pop.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (remember) {
        try { localStorage.setItem(LS_DISMISSED_AT, String(Date.now())); } catch (e) {}
      }
    }

    if (backdrop) backdrop.addEventListener('click', function () { close(true); });
    if (closeBtn) closeBtn.addEventListener('click', function () { close(true); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && pop.classList.contains('is-open')) close(true);
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        submitBtn.disabled = true;
        submitBtn.textContent = 'Envoi…';
        var data = new FormData(form);
        fetch(form.action, { method: 'POST', body: data, credentials: 'same-origin' })
          .then(function (r) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Recevoir mon code';
            if (r.ok || r.type === 'opaqueredirect' || (r.status >= 200 && r.status < 400)) {
              try { localStorage.setItem(LS_SUBSCRIBED, '1'); } catch (e) {}
              body.hidden = true;
              codeText.textContent = WW_POPUP_CODE;
              success.hidden = false;
            } else {
              body.hidden = true;
              error.hidden = false;
            }
          })
          .catch(function () {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Recevoir mon code';
            body.hidden = true;
            error.hidden = false;
          });
      });
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var txt = WW_POPUP_CODE;
        function done() {
          copyBtn.textContent = 'Copié';
          copyBtn.classList.add('is-copied');
          setTimeout(function () { copyBtn.textContent = 'Copier'; copyBtn.classList.remove('is-copied'); }, 2000);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(txt).then(done).catch(done);
        } else {
          done();
        }
      });
    }
  });
})();
